export const delay = async (ms) => new Promise((res) => {
    setTimeout(res, ms);
});
export const scrollToPos = (top = 0, left = 0, headerHeight = 0) => {
    try {
        window.scroll({
            top: top - headerHeight,
            left,
            behavior: 'smooth',
        });
    }
    catch (error) {
        window.scrollTo(left, top - headerHeight);
    }
};
export const buildClickAndKeyDownEvents = (action) => ({
    onClick: (e) => {
        e.stopPropagation();
        action?.();
    },
    onKeyDown: (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === e.currentTarget) {
            e.preventDefault();
            e.stopPropagation();
            action?.();
        }
    },
});
